export enum StepIds {
    ProcessToPDF = 'ecc91dec-1a7f-4874-a23b-12fec261b8ee',
    ProcessNoExpansion = 'c96c63b7-9264-4bc6-ac3b-385a191a6278',
    ForcePlaceholder = 'f9868977-b4c3-486a-859e-6fde8d688719',
    DetectDocLanguage = '4ba43337-52f2-467e-a2d4-d6ba26573f71',
    TranslateDoc = '662ed3bb-f24f-4f2e-b97c-19388ea11157',
    TranscribeDoc = '2ee37cc1-3b47-4083-b4e9-dff9c951edfe',
    DetectImageLabels = '301E70F7-DCAB-4E8D-B9CB-88EFF900D592',
    DetectDocumentEntities = '8F4E2913-9328-4F96-8F4E-647D57A0538F',
    DetectDocumentSentiment = '5FCD3066-4B26-429B-B0D4-5B2CC5E99C8E',
    UpdateGoogleSheet = 'a274cb22-9bed-4e37-bdce-68e3b2016846',
	IndexDoc = '05809b29-19f3-428b-ad90-bab638666db8',
	AnswerResponsivenessPrompt = 'F18B270C-7E02-4386-B879-B34F6A2D2F1E'
}

export class Steps {
    static readonly steps = new Map<string, string>([
        [StepIds.ProcessToPDF, 'Process To PDF'],
        [StepIds.ProcessNoExpansion, 'Process No Expansion'],
        [StepIds.ForcePlaceholder, 'Force Placeholder'],
        [StepIds.DetectDocLanguage, 'Detect Doc Language'],
        [StepIds.TranslateDoc, 'Translate Doc'],
        [StepIds.TranscribeDoc, 'Transcribe Doc'],
        [StepIds.DetectImageLabels, 'Detect Image Labels'],
        [StepIds.DetectDocumentEntities, 'Detect Document Entities'],
        [StepIds.DetectDocumentSentiment, 'Detect Document Sentiment (Email Only)'],
        [StepIds.UpdateGoogleSheet, 'Update Google Sheet'],
		[StepIds.IndexDoc, 'Index Doc'],
		[StepIds.AnswerResponsivenessPrompt, 'Answer Responsiveness Prompt']
    ]);
}
